export default __webpack_public_path__ + "static/media/cs-nut.3cde96ad.webp";